import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import CreateEditSite from "../../components/site/CreateEditSite";

const CreateEditSitePage = (props) => {
    const {
        siteId      = null,
        customerId  = null,
    } = props;

    const handleCancel = () => {
        if (!!siteId) {
            window.location.replace(route('customer.site.show', {
                customer:   customerId,
                site:       siteId
            }).toString());
        } else {
            window.location.replace(route('customer.show', {
                customer:   customerId,
            }).toString());
        }
    }

    const handleComplete = (siteId) => {
        window.location.replace(route('customer.site.show', {
            customer:   customerId,
            site:       siteId
        }).toString());
    }

    const handleDelete = () => {
        window.location.replace(route('customer.show', {
            customer:   customerId,
        }).toString());
    }

    return (
        <div className="m-0 mb-4 p-0">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h1 className="h4 m-0 text-eh-navy">{!!siteId ? "Edit Site" : "Create Site"}</h1>
            </div>
            <CreateEditSite
                siteId={siteId}
                customerId={customerId}
                onCancel={() => handleCancel()}
                onComplete={(siteId) => handleComplete(siteId)}
                onDelete={() => handleDelete()}
                parentId={"create-edit-site-page"}
            />
        </div>
    );
}

export default CreateEditSitePage;

const target = document.getElementById('create-edit-site-page');
if (target) {
    const {
        siteId      = null,
        customerId  = null,
    } = target.dataset;

    ReactDOM.render(<CreateEditSitePage siteId={siteId} customerId={customerId} />, target);
}
